import { Routes } from '@angular/router';
import { adminGuard } from './guards/admin.guard';

/**
 * Rotas da Área Administrativa.
 *
 * Regras obrigatórias:
 * - Nenhuma rota contém tenantId, tenant slug ou qualquer identificador de tenant.
 * - Todas as rotas são protegidas pelo adminGuard (não pelo tenantGuard).
 * - O layout utilizado é AdminLayoutComponent, separado do AppShellComponent.
 * - Toda nova página administrativa deve ser adicionada aqui como filho de 'admin'.
 */
export const adminRoutes: Routes = [
  {
    path: 'admin',
    loadComponent: () =>
      import('./layout/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [adminGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent)
      },
      {
        path: 'health-center',
        loadComponent: () =>
          import('./features/admin-health-center/admin-health-center.component').then(m => m.AdminHealthCenterComponent)
      },
      {
        path: 'operational-console',
        loadComponent: () =>
          import('./features/admin-operational-console/admin-operational-console.component').then(m => m.AdminOperationalConsoleComponent)
      },
      {
        path: 'audit',
        loadComponent: () =>
          import('./features/admin-audit/admin-audit.component').then(m => m.AdminAuditComponent)
      },
      {
        path: 'events',
        loadComponent: () =>
          import('./features/admin-events-center/admin-events-center.component').then(m => m.AdminEventsCenterComponent)
      },
      {
        path: 'tenants',
        loadComponent: () =>
          import('./features/admin-tenants/admin-tenants.component').then(m => m.AdminTenantsComponent)
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/admin-users/admin-users.component').then(m => m.AdminUsersComponent)
      },
      {
        path: 'central-processos',
        loadComponent: () =>
          import('./features/admin-central-processos/admin-central-processos.component').then(m => m.AdminCentralProcessosComponent)
      },
      {
        path: 'queues',
        loadComponent: () =>
          import('./features/admin-queues/admin-queues.component').then(m => m.AdminQueuesComponent)
      },
      {
        path: 'platforms',
        loadComponent: () =>
          import('./features/admin-platforms/admin-platforms.component').then(m => m.AdminPlatformsComponent)
      },
      {
        path: 'billing',
        loadComponent: () =>
          import('./features/admin-billing/admin-billing.component').then(m => m.AdminBillingComponent)
      },
      {
        path: 'billing/:idPlan',
        loadComponent: () =>
          import('./features/admin-billing-edit-plan/admin-billing-edit-plan.component').then(m => m.AdminBillingEditPlanComponent)
      },
      {
        path: 'logs',
        loadComponent: () =>
          import('./features/admin-logs/admin-logs.component').then(m => m.AdminLogsComponent)
      },
      {
        // Webhooks Recebidos — consulta e redisparo (#457 / contrato kram.hub.api#1538)
        path: 'webhooks',
        loadComponent: () =>
          import('./features/admin-webhooks/admin-webhooks.component').then(m => m.AdminWebhooksComponent)
      },
      {
        // Central de Ajuda — curadoria de conteúdo (épica #197 / sub-issue ADM #202)
        path: 'help',
        loadComponent: () =>
          import('./features/admin-help/admin-help.component').then(m => m.AdminHelpComponent)
      }
    ]
  }
];
